import AppText from './AppText'

export default AppText